import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SolicitudAmpliacionSsoModel } from 'src/app/models/calendario-sso/SolicitudAmpliacionSsoModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult, TipoSolicitudAmpliacion } from 'src/app/models/common/enumModel';
import { ISolicitudAmpliacionSsoModel } from 'src/app/models/interfaces/calendario-sso/ISolicitudAmpliacionSsoModel';
import { DetalleSeguimientoPasstModel, SeguimientoPasstModel } from 'src/app/models/passt/SeguimientoPasstModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SolicitudAmpliacionSsoService } from 'src/app/services/solicitud-ampliacion-sso/solicitud-ampliacion-sso.service';

@Component({
  selector: 'app-passt-actividad-solicitar-edicion-dialog',
  templateUrl: './passt-actividad-solicitar-edicion-dialog.component.html',
  styleUrls: ['./passt-actividad-solicitar-edicion-dialog.component.css']
})
export class PasstActividadSolicitarEdicionDialogComponent implements OnInit {

  model:ISolicitudAmpliacionSsoModel
  constructor(public dialogRef: MatDialogRef<PasstActividadSolicitarEdicionDialogComponent>,
    private alertDialogService: AlertDialogService,
    private dialogService: ConfirmDialogService,
    @Inject(MAT_DIALOG_DATA) public data: DetalleSeguimientoPasstModel,
    private service: SolicitudAmpliacionSsoService) { 
      this.model = new SolicitudAmpliacionSsoModel();
      this.model.anio = data.anio;
      this.model.mes = 0;
      this.model.idSede = data.idSede;
      this.model.sede = data.sede;
      this.model.idFichaPasst = data.idPasstActividad;
      this.model.actividad = data.actividad
    }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(form: NgForm) {
    
    if (!form.invalid) {      
      
      
      if (this.model.motivo == '') {
        this.alertDialogService.open('Debe ingresar el motivo de su solicitud');
      } else {
        this.dialogService.open('¿Seguro de enviar la solicitud?'); //options
          this.dialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) {  
              this.model.idTipo = TipoSolicitudAmpliacion.ModificacionActividadPASST;
              this.service.submit(this.model).subscribe((result: ActionResultModel) => {
                console.log(result);
                if(result.type!=eTypeResult.SUCCESS){
                  this.alertDialogService.open(result.message);
                }else{
                  this.dialogRef.close(this.data);
                }
              });
            }
          });
        
      }
    }
  }
}
